import React, { useState } from 'react';
import { connect } from 'react-redux';
import SettingsTitle from '../SettingsTitle';
import { ADMIN_ACCOUNT_NAVIGATION } from '../../../assets/constants/strings';
import { FaEdit, FaTimesCircle, FaCheckCircle } from 'react-icons/fa';
import Loader from '../../Loader';
import { updateUserInfo } from '../../../store/User/userActions';
import $ from 'jquery';
import ChangePassword from './ChangePassword';
// import PhoneNumberInput from '../../Account/PhoneNumberInput';
// import {
//   formatPhoneNumberIntl,
//   isValidPhoneNumber,
// } from 'react-phone-number-input';

const AccountInfo = ({ user, userError, updateUserInfo, loading }) => {
  const [firstName, setFirstName] = useState(user.firstName);
  const [lastName, setLastName] = useState(user.lastName);
  const [email] = useState(user.email);
  const [orgName, setOrgName] = useState(
    user?.userClient?.name ? user?.userClient?.name : ''
  );

  // const [phone, setPhone] = useState(user.phoneNumber ? user.phoneNumber : '');
  // const [jobTitle, setJobTitle] = useState(user.jobTitle ? user.jobTitle : '');

  const [formDisabled, setFormDisabled] = useState(true);
  const [invalidEdit, setInvalidEdit] = useState(false);
  // const [isValidPhone, setIsValidPhone] = useState(false);
  // const [errorMessage, setErrorMessage] = useState('Not a valid phone number.');
  // const [showError, setShowError] = useState(false);

  // useEffect(() => {
  //   if (phone.length > 0) {
  //     setIsValidPhone(isValidPhoneNumber(phone));
  //   }
  // }, [user, phone]);

  const handleEditUser = (e) => {
    e.preventDefault();

    if (
      user.firstName === firstName &&
      user.lastName === lastName &&
      user.userClient.name === orgName
      // && user.phoneNumber === phone
    ) {
      setInvalidEdit(true);
      return;
    } else {
      updateUserInfo({
        id: user.userID,
        firstName: firstName.trim(),
        lastName: lastName.trim(),
        organisation: orgName.trim(),
        // phoneNumber: phone ? phone.trim() : null,
      });
    }
    setFormDisabled(true);
  };

  const handleResetForm = () => {
    setFormDisabled(true);
    setInvalidEdit(false);
    setFirstName(user.firstName);
    setLastName(user.lastName);
    // setPhone(user.phoneNumber ? user.phoneNumber : '');
    // setShowError(false);
  };

  // const handleNumber = () => {
  //   if (phone && phone.length > 0) {
  //     if (isValidPhone) setShowError(false);
  //     else setShowError(true);
  //   }
  // };

  const PasswordComponent = () => {
    return (
      <div className='d-flex flex-column'>
        <label className='mb-0'>Password</label>
        <button
          type='button'
          onClick={() => $('#passwordModal').modal('show')}
          className='my-account-btn secondary ml-0'
        >
          Change Password
        </button>
      </div>
    );
  };

  // const onChangeNumber = (phoneNumber) => {
  //   const newPhone = phoneNumber;
  //   if (newPhone === undefined) setIsValidPhone(false);
  //   else if (newPhone && newPhone.length > 0) {
  //     if (isValidPhoneNumber(newPhone)) {
  //       setIsValidPhone(true);
  //       setPhone(newPhone);
  //       setShowError(false);
  //       setErrorMessage('');
  //     } else {
  //       setShowError(true);
  //       setIsValidPhone(false);
  //       setErrorMessage('Not a valid phone number.');
  //     }
  //   } else setErrorMessage('Please enter your phone number.');
  // };

  return (
    <div id='account-info'>
      <SettingsTitle title={ADMIN_ACCOUNT_NAVIGATION.INFO.TITLE} />
      {loading ? (
        <div className='inner-load'>
          <Loader />
        </div>
      ) : (
        <form onSubmit={handleEditUser} className='user-form'>
          <div className='user-form__row'>
            <div className='form-group'>
              <label htmlFor='firstName'>First Name</label>
              <input
                id='firstName'
                className='form-control'
                type='text'
                minLength={2}
                value={firstName}
                onChange={(e) => {
                  if (!formDisabled) {
                    setFirstName(e.target.value);
                    if (invalidEdit) setInvalidEdit(false);
                    if (
                      e.target.value.match(/[^`'.\-a-zA-Z ]/) ||
                      e.target.value.length < 2
                    ) {
                      e.target.setCustomValidity(
                        'Please enter a valid first name.'
                      );
                    } else {
                      e.target.setCustomValidity('');
                    }
                  }
                }}
                disabled={formDisabled}
                required
              />
            </div>
            <div className='form-group'>
              <label htmlFor='lastName'>Last Name</label>
              <input
                id='lastName'
                className='form-control'
                type='text'
                minLength={3}
                value={lastName}
                onChange={(e) => {
                  if (!formDisabled) {
                    setLastName(e.target.value);
                    if (invalidEdit) setInvalidEdit(false);
                    if (
                      e.target.value.match(/[^`'.\-a-zA-Z ]/) ||
                      e.target.value.length < 3
                    ) {
                      e.target.setCustomValidity(
                        'Please enter a valid last name.'
                      );
                    } else {
                      e.target.setCustomValidity('');
                    }
                  }
                }}
                disabled={formDisabled}
                required
              />
            </div>
          </div>
          <div className='user-form__row'>
            <div className='form-group wf-hover'>
              <label htmlFor='email'>Email</label>
              <input
                id='email'
                className='form-control'
                type='text'
                value={email}
                disabled
              />
              <span
                className='wf-hover__text'
                title='Your email address is your unique identifier in RegulationCity, therefore, it cannot be changed.'
              >
                Cannot be Edited
              </span>
            </div>
            <div className='form-group'>
              <label htmlFor='orgName'>Organisation Name</label>
              <input
                id='orgName'
                className='form-control'
                type='text'
                value={orgName ? orgName : ''}
                disabled={formDisabled}
                onChange={(e) => setOrgName(e.target.value)}
              />
            </div>
          </div>
          {/* <div className='user-form__row'>
            <div className='form-group'>
              <label htmlFor='jobTitle'>Job Title (Optional)</label>
              <input
                id='jobTitle'
                className='form-control'
                type='text'
                minLength={2}
                value={jobTitle}
                onChange={(e) => {
                  if (!formDisabled) {
                    setJobTitle(e.target.value);
                    if (invalidEdit) setInvalidEdit(false);
                    if (
                      e.target.value.match(/[^`'.\-a-zA-Z ]/) ||
                      e.target.value.length < 2
                    ) {
                      e.target.setCustomValidity('Please enter a valid title.');
                    } else {
                      e.target.setCustomValidity('');
                    }
                  }
                }}
                disabled={formDisabled}
              />
            </div>
            <div className='form-group'>
              <label>Mobile Number (Optional)</label>
              <PhoneNumberInput
                showPlaceholder={false}
                phoneValue={formatPhoneNumberIntl(phone)}
                disabled={formDisabled}
                onChangeNumber={(phoneNumber) => onChangeNumber(phoneNumber)}
                showError={showError}
                handleNumberBlur={handleNumber}
                handleNumberFocus={() => setShowError(false)}
                errorMessage={errorMessage}
              />
            </div>
          </div> */}
          <div className='user-form__row'>
            <PasswordComponent />
          </div>
          {userError && !loading && (
            <span className='text-danger my-3 font-weight-bold'>
              {userError.reason}
            </span>
          )}
          {invalidEdit && (
            <label id='NoChange' className='my-3'>
              * No field was updated. Please update any of the fields in order
              to proceed or click "Cancel" to exit editing.
            </label>
          )}
          {formDisabled ? (
            <button
              type='button'
              className='my-account-btn d-flex align-items-center'
              onClick={() => setFormDisabled(false)}
            >
              <FaEdit className='mr-2' />
              Edit
            </button>
          ) : (
            <div className='d-flex'>
              <button
                type='reset'
                className='my-account-btn secondary d-flex align-items-center'
                onClick={handleResetForm}
              >
                <FaTimesCircle className='mr-2' />
                Cancel
              </button>
              <button
                type='submit'
                className='my-account-btn d-flex align-items-center'
                // disabled={
                //   (phone && phone.length > 0 && !isValidPhone) || phone === ''
                // }
              >
                <FaCheckCircle className='mr-2' />
                Save
              </button>
            </div>
          )}
        </form>
      )}
      <ChangePassword />
    </div>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  userError: state.user.userError,
  loading: state.user.loading,
});

const mapDispatchToProps = { updateUserInfo };

export default connect(mapStateToProps, mapDispatchToProps)(AccountInfo);
